import { jsx as _jsx } from "react/jsx-runtime";
import ErrorSystemIcon from "@nib/icons/system/Error";
import * as S from "./StatusIconError.style";
const StatusIconError = () => _jsx(S.Wrapper, {
  children: _jsx(ErrorSystemIcon, {
    size: "xs",
    fill: "#FFF"
  })
});
export default StatusIconError;
export * as Styles from "./StatusIconError.style";